import { Calendar } from 'primereact/calendar'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { createElement } from 'react'

/**
 * PrimeReact Calendar preconfigured for day/month input (dd/mm format, appended to self).
 * Renders inside an IconField with a calendar icon unless icon is explicitly falsy.
 *
 * @component
 * @param {Object} props - Component props, forwarded to the underlying PrimeReact Calendar
 * @param {string} [props.icon="fa-regular fa-calendar"] - Icon class name, set to a falsy value to disable the icon wrapper
 * @returns {JSX.Element}
 */
export default function DateDayMonthInput(props) {
  const options = {
    icon: 'fa-regular fa-calendar',
    ...props,
    dateFormat: 'dd/mm',
    appendTo: 'self'
  }

  const field = createElement(Calendar, options)

  if (options.icon) {
    return (
      <IconField>
        {field}
        <InputIcon className={options.icon} />
      </IconField>
    )
  }
  return field
}

DateDayMonthInput.displayName = 'DateDayMonthInput'
